export const ArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M10.8065 5.33345H5.19314C4.97153 5.33313 4.75436 5.39557 4.56677 5.51356C4.37917 5.63154 4.22883 5.80023 4.13314 6.00012C4.02111 6.23728 3.97797 6.50114 4.00861 6.76163C4.03926 7.02212 4.14246 7.26876 4.30647 7.47345L7.11314 10.8734C7.22328 11.0005 7.35946 11.1025 7.51244 11.1723C7.66542 11.2422 7.83163 11.2783 7.9998 11.2783C8.16798 11.2783 8.33419 11.2422 8.48717 11.1723C8.64015 11.1025 8.77632 11.0005 8.88647 10.8734L11.6931 7.47345C11.8571 7.26876 11.9603 7.02212 11.991 6.76163C12.0216 6.50114 11.9785 6.23728 11.8665 6.00012C11.7708 5.80023 11.6204 5.63154 11.4328 5.51356C11.2452 5.39557 11.0281 5.33313 10.8065 5.33345Z"
        fill="#434343"
      />
    </svg>
  );
};
